import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createGroup } from "../services/group.services";
import { GROUPS_QUERY_KEYS } from "../queryKeys";
import { GroupFormData } from "../types/group.types";

type CreateGroupVariables = {
  entityId: number;
  data: GroupFormData;
};

export const useCreateGroupMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ entityId, data }: CreateGroupVariables) => createGroup(entityId, data),
    onSuccess: (_, { entityId }) => {
      queryClient.invalidateQueries({
        queryKey: GROUPS_QUERY_KEYS.groupsList(entityId),
      });
    },
  });
};
